import { useEffect } from 'react'

const PIXEL_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

type PixelWindow = Window & {
  fbq?: Fbq
  _fbq?: Fbq
}

let pageViewTracked = false

function loadPixel(): Fbq {
  const win = window as PixelWindow

  if (win.fbq) {
    return win.fbq
  }

  const fbq = function (this: unknown, ...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue.push(args)
    }
  } as Fbq

  fbq.queue = []
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'

  win.fbq = fbq
  if (!win._fbq) {
    win._fbq = fbq
  }

  const script = document.createElement('script')
  script.async = true
  script.src = PIXEL_SRC

  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  return fbq
}

/**
 * Loads the Meta Pixel and fires a single PageView on mount.
 * Safe against React StrictMode double-mounting.
 */
export function useMetaPixel(pixelId: string): void {
  useEffect(() => {
    if (typeof window === 'undefined' || pageViewTracked) {
      return
    }

    pageViewTracked = true

    const fbq = loadPixel()
    fbq('init', pixelId)
    fbq('track', 'PageView')
  }, [pixelId])
}
